import React from 'react';
import TypeScale from '@identity/type';
import Icons from '@components/Icons';

import Image from '@components/Image';
import { Content } from '@identity/wrappers';
import { ServiceContainer, ServicesWrapper, IconWrapper } from './styles';

const Services = ({ title, service }) => {
  return (
    <React.Fragment>
      <ServicesWrapper>
        {service &&
          service.map(({ title, description, logo, id }, index) => (
            <ServiceContainer key={id} color={index}>
              <Image src={logo.file.url} />
              <TypeScale.H4
                spacing={{ padding: 'vertical-md' }}
                alignText="center"
              >
                {title}
              </TypeScale.H4>
              <TypeScale.P>{description.description}</TypeScale.P>
            </ServiceContainer>
          ))}
      </ServicesWrapper>
    </React.Fragment>
  );
};

export default Services;
